import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const PrevButton = styled.button`
  width: 40px;
  height: 40px !important;
  margin-left: 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: transparent !important;
  color: transparent !important;
  border: none;
  &:hover {
    background: #fff !important;
    color: #707070 !important;
    transition: all 0.3s ease-in;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NextButton = styled(PrevButton)`
  margin-right: 10px;
`;
